// removed by extract-text-webpack-plugin
module.exports = {"backgroundImage":"styles__backgroundImage___2Pefn","img":"styles__img____Lnik","heading":"styles__heading___2As2H"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/mastheadBackground/styles.css
// module id = 158s
// module chunks = 3